import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mb_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (typeof window !== "undefined") {
      const status = error?.response?.status;
      const requestUrl = String(error?.config?.url || "");
      const requestMethod = String(error?.config?.method || "get").toUpperCase();
      const payload = {
        status,
        url: requestUrl,
        method: requestMethod,
        detail: error?.response?.data?.detail || "",
      };

      if (status === 401 && !requestUrl.includes("/auth/login")) {
        localStorage.removeItem("mb_token");
        window.dispatchEvent(new CustomEvent("mb:auth-expired", { detail: payload }));
        if (window.location.pathname.startsWith("/admin") && !window.location.pathname.startsWith("/admin/login")) {
          const next = encodeURIComponent(`${window.location.pathname}${window.location.search}`);
          window.location.replace(`/admin/login?expired=1&next=${next}`);
        }
      } else if (status === 403) {
        window.dispatchEvent(new CustomEvent("mb:forbidden", { detail: payload }));
        if (window.location.pathname.startsWith("/admin")) {
          window.location.replace("/forbidden");
        }
      } else if (status >= 500) {
        window.dispatchEvent(new CustomEvent("mb:server-error", { detail: payload }));
      }
    }
    return Promise.reject(error);
  },
);

export function mediaUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export function getInvestmentAddress(address) {
  if (!address) {
    return { address: "", lat: null, lng: null };
  }
  if (typeof address === "string") {
    return { address, lat: null, lng: null };
  }
  return {
    address: address.address || address.formatted_address || address.location || address.label || address.name || "",
    lat: address.lat ?? address.latitude ?? null,
    lng: address.lng ?? address.longitude ?? address.lon ?? null,
  };
}

export function formatInvestmentAddress(address, fallback = "—") {
  return getInvestmentAddress(address).address || fallback;
}

export function formatCurrency(value, currency = "EUR") {
  if (value == null) return "—";
  try {
    return new Intl.NumberFormat("ro-RO", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `${value} ${currency}`;
  }
}

export function formatNumber(value) {
  if (value == null) return "0";
  return new Intl.NumberFormat("ro-RO").format(value);
}

export function normalizeInvestmentStatus(status) {
  const value = String(status || "").trim().toLowerCase();
  if (value === "completed" || value === "in_progress" || value === "in_analysis") return value;
  return "in_analysis";
}

export const STATUS_LABELS = {
  completed: "Finalizat",
  in_progress: "În execuție",
  in_analysis: "În analiză",
};

export const STATUS_STYLES = {
  completed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  in_progress: "bg-blue-50 text-blue-800 border-blue-200",
  in_analysis: "bg-rose-50 text-rose-800 border-rose-200",
};

export const STATUS_COLORS = {
  completed: "#16A34A",
  in_progress: "#2563EB",
  in_analysis: "#DC2626",
};
